import { Component, Vue } from 'vue-property-decorator';
import LineItem from '@/services/line_item.ts';
import Shops from '@/services/shops.ts';
import RequestFulfillment from './_request_fulfillment/RequestFulfillment.vue';
import RequestExternalFulfillment from "./_request_external_fulfillment/RequestExternalFulfillment.vue";
import InfoCustomer from "../order/InfoCustomer.vue";
import { format, isThisISOWeek } from 'date-fns';
import { pickBy as _pickBy } from 'lodash';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';

Vue.use(Buefy);

@Component({
  components: {
    RequestFulfillment,
    RequestExternalFulfillment,
    InfoCustomer,
  }
})
export default class Order extends Vue {
  lineItemService = new LineItem();
  shopService = new Shops();

  isLoadingExport = false;

  shops: any[] = [];
  orders: any = {};
  lineItems: any[] = [];
  totalData: number = 0;
  perPage: number = 50;
  currentPage: number = 1;
  isLoading = false;
  statuses = [
    'PENDING',
    'REQUEST_FULFILLED',
    'REQUEST_SUPPLIER_FULFILLED',
    'REQUEST_EXT_SUPPLIER_FULFILLED',
    'PARTIALLY_FULFILLED',
    'FULFILLED',
  ]
  order_statuses = [
    'PENDING',
    'VOID',
    'PAID',
    'PARTIALLY_FULFILLED',
    'FULFILLED',
    'CANCELLED',
    'PARTIALLY_REFUNDED',
    'REFUNDED',
  ]
  init_query = {
    limit: this.perPage,
    offset: 0,
    shop_domain: [],
    status: [],
    order_status: [],
    sku: "",
    order_name: "",
    email: '',
    tracking_number: '',
    transaction_id: '',
    shopify_created_at_min: null,
    shopify_created_at_max: null,
    dates: null,
  }
  query = JSON.parse(JSON.stringify(this.init_query));
  requestingFulfillment = false;
  requestingExternalFullfillment = false;

  async mounted() {
    this.fetch();
    const shopRes: any = await this.shopService.index();
    this.shops = shopRes.shops;
  }

  async fetch(reset=false) {
    if(reset) {
      this.query = JSON.parse(JSON.stringify(this.init_query));
    }
    const query: any = _pickBy({ ...this.query }, (v: any, k: any) => ![null, ''].includes(v));

    if (Array.isArray(query.dates) && query.dates.length === 2) {
      query.shopify_created_at_min = format(query.dates[0], 'YYYY-MM-DD 00:00:00+07:00');
      query.shopify_created_at_max = format(query.dates[1], 'YYYY-MM-DD 23:59:59+07:00');
    }
    delete query.dates;

    this.isLoading = true;
    try {
      const res: any = await this.lineItemService.index({...query})
      this.totalData = res.total;
      this.lineItems = res.line_items;
    } catch(e) {
      console.log(e)
    } finally {
      this.isLoading = false;
    }
  }

  public async changePage(page: number) {
    if (page === 0) {
      return;
    }
    this.currentPage = page;
    this.query.offset = (this.currentPage - 1) * this.query.limit || 0;
    await this.fetch();
  }

  public async filter() {
    this.query.offset = 0;
    await this.fetch();
    this.currentPage = 1;
  }

  public getColorStatus(status: any){
    let color = 'is-info';
    
    switch(status) {
      case 'PENDING': 
        color = 'is-warning';
        break;
      case 'REQUEST_FULFILLED':
        color = 'is-info';
        break;
      case 'REQUEST_EXT_SUPPLIER_FULFILLED':
        color = 'is-primary';
        break;
      case 'PARTIALLY_FULFILLED':
        color = 'is-success';
        break;
      case 'FULFILLED':
        color = 'is-success';
        break;
      case 'REQUEST_EXT_SUPPLIER_FULFILLED':
        color = 'is-primary';
        break;
      default:
        break;
    }

    return color;
  }

  public getColorOrderStatus(status: any) {
    let color = 'is-info';
    
    switch(status) {
      case 'PENDING': 
        color = 'is-warning';
        break;
      case 'VOID':
        color = 'is-warning';
        break;
      case 'PAID':
        color = 'is-warning';
        break;
      case 'PARTIALLY_FULFILLED':
        color = 'is-success';
        break;
      case 'FULFILLED':
        color = 'is-success';
        break;
      case 'CANCELLED':
        color = 'is-danger';
        break;
      case 'PARTIALLY_REFUNDED':
        color = 'is-danger';
        break;
      case 'REFUNDED':
        color = 'is-info';
        break;
      default:
        break;
    }

    return color;
  }

  public async exportCsv(file_format: string = 'staff') {
    const fileDownload = require('js-file-download');
    const currentDate = format(new Date, 'MM-DD-YYYY_HH-mm-ss');

    try {
      this.isLoadingExport = true;
      const {limit, offset, ...query_filters} = this.query;

      this.$buefy.toast.open({
        duration: 5000,
        message: 'Be patient, your export request is in progress!',
        position: 'is-top',
        type: 'is-warning',
      })
      const res: any = await this.lineItemService.indexCsv({
        ...query_filters,
        output: 'csv',
        file_format
      })
      
      fileDownload(res, `guardian_export_${currentDate}.csv`);
    } catch(e) {
      console.log(e)
    } finally {
      this.isLoadingExport = false;
    }
  }
}


